module.exports = __webpack_public_path__ + "media/images/thumbs/physanims/a7-0-d89d06ddf6f80057246b3415b1a3f62a.jpg";